<template>
  <div class="pa-0">
    <!-- <label class="darkblue--text">Upload {{ title }} Document</label> -->
    <vue-dropzone
      :use-font-awesome="true"
      ref="myVueDropzone"
      id="dropzone"
      :options="options"
      @vdropzone-complete="afterComplete"
      @vdropzone-reset="fileRemoved()"
    ></vue-dropzone>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
  components: {
    vueDropzone: vue2Dropzone
  },
  props: {
    options: {
      type: Object
    }
  },
  methods: {
    afterComplete(file) {
      this.$emit('afterComplete', { file });
    },
    fileRemoved() {
      this.$refs.myVueDropzone.removeAllFiles();
    }
  }
};
</script>
